import React, { Component } from 'react'
import TableWrapper from './TableWrapper'
import { FormLabel, FormGroup } from 'react-bootstrap'
import { FormInput } from '../ui/FormInput'

@TableWrapper
export default class Users extends Component {
  constructor(props) {
    super(props)
    this.store = this.props.store.editorStore
    this.title = 'Пользователи'
    this.editFilter = ['rec_date', 'id', 'role', 'role_id']
    this.columnFilter = ['is_disabled', 'password', 'id', 'rec_date', 'role_id']
  }

  renderItem() {
    return (
      <FormGroup className='form-group row'>
        <FormLabel className='col-12 col-sm-3'>Роль:</FormLabel>
        <div className='col-12 col-sm-6'>
          <FormInput type='select' name='item.role_id' model={this.store}>
            {this.props.store.adminStore.roles &&
              this.props.store.adminStore.roles.map(role => (
                <option key={role.id} value={role.id}>
                  {role.name}
                </option>
              ))}
          </FormInput>
        </div>
      </FormGroup>
    )
  }
}
